'use client';

/**
 * @packageDocumentation
 * @category Page
 */

import moduleStyles from 'Workadabra/app/styles.module.css';
import { Button, Fallback } from '@bomdisoft/components';
import { getLanguageCode, somethingWentWrongT, tryAgain } from '@bomdisoft/translations';
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

const GlobalError = ({ reset, error }: { error: Error & { digest?: string }; reset: () => void }) => {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang={getLanguageCode('english')}>
      <body>
        <div className={moduleStyles.errorBox}>
          <Fallback message={somethingWentWrongT.english} />
          <Button color='info' onClick={() => reset()} variant='contained'>
            {tryAgain.english}
          </Button>
        </div>
      </body>
    </html>
  );
};

export default GlobalError;
